import { Extend } from '~/components/_table/hooks/use-table-fetch';
import { TableInstance } from 'react-table';
import { OnOpenExportParams } from '~/components/_table/hooks/use-table-export/types';

export const buildExportParamsFromTable = <T extends Extend>(instance: TableInstance<T>): OnOpenExportParams<T> => {
  const { selectedFlatRows, isAllPageRowsSelected, state } = instance;
  const isExportAll = Boolean(isAllPageRowsSelected || !selectedFlatRows.length);
  return { filtersBy: state.filters, selectedFlatRows, isExportAll };
};
